import { itemsOnPage } from 'features/slotsHistory/model/data';

export class SlotsHistoryConverter {
  convertSlotsHistory = data => {
    return {
      list:
        data?.data?.map(t => ({
          date: t.date,
          amount: t.amount,
          status: t.status,
          provider: t.provider,
          userID: t.user_id,
          username: t.username,
        })) || [],
      pageCount: Math.ceil(data?.totalCount / itemsOnPage),
    };
  };
}
